module.exports = "../../static/img/instagram.7baf6c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/instagram.png
// module id = zdYi
// module chunks = 1